import React from "react";
import "./MediaComponent.css";

const MediaComponent = ({
  src,
  alt,
  className = "",
  autoPlay = true,
  controls = true,
  muted = true,
  loop = false,
  isPreview = false,
  fileType = null, // New prop to specify file type directly
}) => {
  if (!src) {
    return (
      <div className={`media-placeholder ${className}`}>
        <p>Media not available</p>
      </div>
    );
  }

  // Get file extension to determine media type
  const getFileExtension = (url) => {
    const path = url.split("?")[0]; // Remove query parameters if any
    return path.split(".").pop().toLowerCase();
  };

  // Use provided fileType or detect from URL extension
  let fileExtension;
  if (fileType) {
    // Extract extension from MIME type (e.g., "video/mp4" -> "mp4")
    fileExtension = fileType.split("/").pop().toLowerCase();
  } else {
    fileExtension = getFileExtension(src);
  }

  const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi"];
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];

  // Determine media type - use fileType MIME type if available, otherwise use extension
  const isVideo = fileType
    ? fileType.startsWith("video/")
    : videoExtensions.includes(fileExtension);
  const isImage = fileType
    ? fileType.startsWith("image/")
    : imageExtensions.includes(fileExtension);

  if (isVideo) {
    const videoProps = isPreview
      ? {
          autoPlay: false,
          controls: false,
          muted: true,
          loop: false,
        }
      : {
          autoPlay,
          controls,
          muted,
          loop,
        };

    return (
      <div
        className={`media-video-container ${
          isPreview ? "preview-mode" : ""
        } ${className}`}>
        <video
          key={src} // Force re-render when source changes
          className={`media-video ${className}`}
          src={src}
          {...videoProps}
          onError={(e) => {
            console.error("Video loading error:", e);
          }}>
          <source
            src={src}
            type={fileType || `video/${fileExtension}`}
          />
          Your browser does not support the video tag.
        </video>
      </div>
    );
  }

  if (isImage) {
    return (
      <img
        key={src} // Force re-render when source changes
        src={src}
        alt={alt}
        className={`media-image ${className}`}
        onError={(e) => {
          console.error("Image loading error:", e);
        }}
      />
    );
  }

  // Fallback for unknown file types
  return (
    <div className={`media-placeholder ${className}`}>
      <p>Unsupported media format: {fileExtension}</p>
      <p>
        Supported formats: Images (jpg, png, gif, etc.) and Videos (mp4, webm,
        etc.)
      </p>
    </div>
  );
};

export default MediaComponent;
